import {getField, updateField} from 'vuex-map-fields'
import {F} from '../../ladmin/utils'
import cfg from '@/config'
import {Person} from '@/object'
import {Institution, LError} from '../../object'
import {handleError} from '../handleError'
import axios from 'axios'
let LOGIN_INFO_KEY = 'loginInfo'
let TIMEOUT = 10000

function LoginInfo ({token, name, id}) {
  this.token = token || ''
  this.name = name || ''
  this.id = id || ''
  // this.permission = permission || {}
}

function _buildAccess (tree, access, prefix) {
  if (!F.isObj(tree)) {
    access.push(prefix)
    return
  }
  for (let key of Object.keys(tree)) {
    _buildAccess(tree[key], access, prefix + cfg.permissionSeq + 'key')
  }
  return access
}

function buildAccess (tree) {
  return _buildAccess(tree, [], '')
}

const state = {
  token: '',
  name: '',
  id: '',
  self: new Person(),
  access: {},
  isInit: false,
  exitDialog: {
    count: 0,
    reason: '由于长时间未操作, 您的登录信息已失效'
  },
  permission: {},
  availableInstitutions: [],
  currentInstitution: [],
  exitDialogActivate: false,
  currentOrg: {},
  initSystemFinished: false
}
const getters = {
  getField,
  isLogin (state) {
    return !!state.token && state.isInit
  },
  isGetToken (state) {
    return !!state.token
  },

  getPermission (state) {
    return state.permission
  },
  hasPermissionOf: (state) => (p) => {
    return F.haveTruthyAttr(state.permission, p, false, true, ':')
  },
  getAccess (state) {
    return buildAccess(state.permission)
  },
  institution (state) {
    return state.self.institution
  },
  insId (state, getters) {
    return getters.institution && getters.institution.id
  },
  insName (state, getters) {
    return getters.institution && getters.institution.name
  },
  orgName (state, getters) {
    return getters.getCurrentOrg.name
  },
  getCurrentOrg (state) {
    return state.currentOrg
  },
  getAvailableInstitutions (state) {
    return state.availableInstitutions
  }
}

const mutations = {
  updateField,
  setInitSystemFinished (state, val) {
    state.initSystemFinished = val
  },
  setInit (state, val) {
    state.isInit = val
  },
  clearInit (state) {
    state.isInit = false
    state.permission = {}
  },
  saveInfo (state, info) {
    let loginInfo = new LoginInfo(info)
    for (let key of Object.keys(loginInfo)) {
      state[key] = loginInfo[key]
    }
    F.saveToLocal(LOGIN_INFO_KEY, loginInfo)
  },
  setSelf (state, self) {
    // console.log('set self', self)
    if (self instanceof Person) {
      state.self = self
    }
    else {
      state.self = new Person()
    }

    // console.log('set', state.self)
  },
  setCurrentOrg (state, data) {
    state.currentOrg = data
  },
  setPermission (state, permission) {
    state.permission = permission
  },
  deleteInfo (state) {
    state.token = ''
    state.name = ''
    state.id = ''
    state.permission = {}
    F.deleteLocal(LOGIN_INFO_KEY)
  },
  recoveryLogin () {
    let info = F.getFromLocal(LOGIN_INFO_KEY) || {}
    let loginInfo = new LoginInfo(info)
    for (let key of Object.keys(loginInfo)) {
      state[key] = loginInfo[key]
    }
  },
  openExitDialog (state, {second, reason}) {
    state.exitDialog.count = second
    if (reason) {
      state.exitDialog.reason = reason
    }
    state.exitDialogActivate = true
  },
  setAvailableIns (state, items) {
    state.availableInstitutions = items
  }
}

const actions = {
  async login ({dispatch, commit}, {loginId, password, verifyKey, type}) {
    let message = {
      url: type === 'portal' ? '/shiroApi/auth/thirdpart/login?pipe=uestc-portal' : '/shiroApi/auth',
      method: 'post',
      data: {
        'username': loginId,
        'password': password,
        'verifyKey': verifyKey
      },
      timeout: TIMEOUT
    }
    let {Authorization, name, username} = await dispatch('getDataFromApi', message, {root: true})
    if (!Authorization) {
      throw new LError('该用户未授权', -1)
    }
    let loginInfo = new LoginInfo({
      token: Authorization,
      name: name,
      id: username
    })
    commit('saveInfo', loginInfo)
    // console.log('login', loginInfo.name)
    return loginInfo
    // your login dispatch
    // throw error when login failed
  },
  // 获取全局系统信息
  async initSystemInfoWx ({dispatch, commit}, force = false) {
    try {
      let data = await Promise.all([
        dispatch('initControllers')
      ])
      commit('setInitSystemFinished', true)
      commit('setInit', true)
      console.log('system init', data)
    }
    catch (e) {
      if (force) {
        commit('setInit', true)
      }
      else {
        throw e
      }
    }
  },
  // 获取全局系统信息
  async initSystemInfo ({dispatch, commit}, force = false) {
    try {
      let data = await Promise.all([
        dispatch('getPermission'),
        // dispatch('getRole'),
        dispatch('getSelfInfo'),
        dispatch('initControllers'),
        //dispatch('getNotifications')
      ])
      commit('setInitSystemFinished', true)
      commit('setInit', true)
      console.log('system init', data)
    }
    catch (e) {
      if (force) {
        commit('setInit', true)
      }
      else {
        throw e
      }
    }
  },
  async getNotifications ({dispatch}) {
    return dispatch('message/getUnreadNotifications', state.id, {root: true})
  },
  async initControllers ({dispatch}) {
    return dispatch('parkingLot/initControllers', null, {root: true})
  },
  async getVerifyImg ({dispatch}) {
    let {key} = await dispatch('getDataFromApi', {
      method: 'get',
      url: '/verifyApi/validate/token',
      timeout: TIMEOUT
    }, {root: true})
    let {verify, verifyKey, msg} = await dispatch('getDataFromApi', {
      method: 'post',
      url: `/verifyApi/validate/verify/${key}/pipe/web`,
      timeout: TIMEOUT
    }, {root: true})
    return {img: verify, key: verifyKey, msg: msg}
  },
  async checkVerify ({dispatch}, {key, code}) {
    return dispatch('getDataFromApi', {
      method: 'post',
      url: '/verifyApi/validate/check',
      timeout: TIMEOUT,
      data: {
        'verifyKey': key,
        'realMsg': code
      }
    }, {root: true})
  },
  async getPermission ({dispatch, commit}) {
    let data = await dispatch('getDataFromApi', {
      url: '/shiroApi/viewPermission',
      method: 'get',
      timeout: TIMEOUT
    }, {root: true})
    let permission = data.permission
    let list = [].concat(permission.menu, permission.button, permission.element)
    let groups = {}
    list.forEach(l => {
      let s = l.split(':')
      let o = groups
      s.forEach(si => {
        if (!o[si]) {
          o[si] = {}
        }
        o = o[si]
      })
    })
    console.log('get permission', groups)
    commit('setPermission', groups)
    return groups
  },
  async getSelfInfo ({dispatch, commit}) {
    let info = await dispatch('getDataFromApi', {
      method: 'get',
      url: '/shiroApi/selfInfo',
      timeout: TIMEOUT
    }, {root: true})

    let self = info.userInfo || {}
    let selfConfig = info.selfConfig || {}
    if(selfConfig.currentReg!==undefined){
      self.authType = selfConfig.currentReg.name
      self.regCode = +selfConfig.currentReg.code
    }
    self.institution = Institution.fromAPI(selfConfig.currentInst)
    // console.log('get self', self)
    let p = Person.fromAPI(self)
    commit('setSelf', p)
    if(selfConfig.currentOrg !== undefined){
      commit('setCurrentOrg', selfConfig.currentOrg)
    }
    console.log('setSelf', p)
    return p
  },
  async getThemSelfInfo ({dispatch, commit},id) {
    let info = await dispatch('getDataFromApi', {
      method: 'post',
      url: '/shiroApi/themselvesInfo?id=' + id + '&pipe=loginId',
      timeout: TIMEOUT
    }, {root: true})
    let self = info.userInfo || {}
    let selfConfig = info.selfConfig || {}
    if(selfConfig.currentReg!==undefined){
      self.authType = selfConfig.currentReg.name
    }
    if(selfConfig.currentOrg!==undefined){
      self.orgName = selfConfig.currentOrg.name
    }
    self.institution = Institution.fromAPI(selfConfig.currentInst)
    // console.log('get self', self)
    let p = Person.fromAPI(self)
    return p
  },
  // async getRole ({dispatch, commit}) {
  //   let role = await dispatch('getDataFromApi', {
  //     url: '/shiroApi/auth/roles',
  //     method: 'post',
  //     timeout: 5000,
  //   }, {root: true})
  //   console.log('get Role', role)
  //   return role
  // },
  async getAvailableIns ({dispatch, commit}) {
    let items = await dispatch('getDataFromApi', {
      method: 'get',
      url: '/shiroApi/insts'
    }, {root: true})
    commit('setAvailableIns', items)
    return items.map(item => Institution.fromAPI(item))
  },
  async getAvailableOrg ({dispatch}) {
    let items = await dispatch('getDataFromApi', {
      method: 'get',
      url: '/shiroApi/orgs'
    }, {root: true})
    return items
  },
  async switchCurrentIns ({dispatch}, institution) {
    if (institution instanceof Institution) {
      let item = await dispatch('getDataFromApi', {
        method: 'put',
        url: `/shiroApi/currentInst/${institution.id}`
      }, {root: true})
      return item instanceof Object ? Institution.fromAPI(item) : institution
    }
    else {
      throw new LError('切换机构失败')
    }
  },
  async switchCurrentOrg ({dispatch}, org) {
    if (org instanceof Object) {
      let item = await dispatch('getDataFromApi', {
        method: 'put',
        url: `/shiroApi/currentOrg/${org.id}`
      }, {root: true})
      return item instanceof Object ? {name: item} : item
    }
    else {
      throw new LError('切换单位失败')
    }
  },
  async changeSelfInfo ({dispatch, commit}, person) {
    // Fixme 需要支持仅修改个人
    let newPerson = await dispatch('userAdmin/setUser', person, {root: true})
    commit('setSelf', newPerson)
  },
  async changePassword ({dispatch}, {newPassword, oldPassword}) {
    return dispatch('getDataFromApi', {
      method: 'put',
      url: '/shiroApi/user/passwd',
      data: {
        'originPasswd': oldPassword,
        'newPasswd': newPassword
      }
    }, {root: true})
  },
  async changeEmail ({dispatch}, {email}) {
    return dispatch('getDataFromApi', {
      method: 'put',
      url: '/shiroApi/mail',
      params: {
        mail: email
      }
    }, {root: true})
  },
  async changePhone ({dispatch}, {phone}) {
    return dispatch('getDataFromApi', {
      method: 'put',
      url: '/shiroApi/phone',
      params: {
        phone: phone
      }
    }, {root: true})
  },
  async logout ({dispatch, commit}, silent = false) {
    try {
      if (!silent) {
        await dispatch('getDataFromApi', {
          method: 'get',
          url: '/shiroApi/logout'
        }, {root: true})
        // your logout dispatch
      }
    }
    catch (e) {
      // throw e
    }
    finally {
      commit('deleteInfo')
      commit('clearInit')
      dispatch('L/tab/clearAll', null, {root: true})
    }
    return true
  },
  async wxLoginOut({dispatch,commit}){
    commit('deleteInfo')
    commit('clearInit')
  },
  async logoutCount ({dispatch, commit}, {second, reason}) {
    dispatch('L/closeAlert', null, {root: true})
    commit('openExitDialog', {second, reason})
    return true
  },
  async refresh ({dispatch}) {
    let url = '/shiroApi/refresh'
    try {
      let res = await axios.get(url)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
